/**
 * Vervado YouTube Responsive Fix v2
 * - Wraps YouTube iframes so they never overflow on mobile
 * - Handles iframes stuck inside <p> tags (common in Shopify RTE)
 * - Safe to run multiple times
 */
(function () {
  function isYouTube(iframe) {
    var src = (iframe.getAttribute('src') || '') + (iframe.getAttribute('data-src') || '');
    return src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1;
  }

  function alreadyWrapped(iframe) {
    return !!(iframe.closest && iframe.closest('.video-responsive'));
  }

  function wrapIframe(iframe) {
    if (!iframe || alreadyWrapped(iframe)) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'video-responsive';

    var parent = iframe.parentNode;
    if (!parent) return;

    // If iframe is inside a <p> (Shopify often does this), move the iframe
    // out and insert the wrapper in place of the paragraph when the p
    // only contains the iframe (or empty text nodes).
    if (parent.tagName && parent.tagName.toLowerCase() === 'p') {
      var onlyIframe = true;
      for (var i = 0; i < parent.childNodes.length; i++) {
        var n = parent.childNodes[i];
        if (n === iframe) continue;
        if (n.nodeType === 3 && !n.textContent.trim()) continue; // whitespace text
        if (n.nodeType === 1 && n.tagName && n.tagName.toLowerCase() === 'br') continue;
        onlyIframe = false;
        break;
      }

      if (onlyIframe && parent.parentNode) {
        parent.parentNode.insertBefore(wrapper, parent);
        wrapper.appendChild(iframe);
        // Remove empty <p>
        if (parent.parentNode) parent.parentNode.removeChild(parent);
      } else {
        parent.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
      }
    } else {
      parent.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }

    // Strip fixed dimensions that cause horizontal overflow
    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.maxWidth = 'none';
  }

  function makeResponsive() {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (isYouTube(iframes[i])) {
        try {
          wrapIframe(iframes[i]);
        } catch (e) {
          // fail silently per iframe
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeResponsive);
  } else {
    makeResponsive();
  }

  // Shopify theme editor / section reloads
  document.addEventListener('shopify:section:load', makeResponsive);

  // In case embeds are injected late
  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        makeResponsive();
      }, 100);
    });
    if (document.body) {
      obs.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        obs.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();
